import $ from "jquery";

export function menu() {
  $('#js-menu-btn').click(() => {

    if ($('#js-menu').hasClass('is-active')) {
      //menuが開いている場合
      $('#js-menu-btn')
        .addClass('is-no-active')
        .one('animationend', function () {
          $('#js-menu-btn').removeClass('is-active');
          $('#js-menu-btn').removeClass('is-no-active');
        });
      //menu
      $('#js-menu')
        .addClass('is-no-active')
        .one('animationend', function () {
          $('#js-menu').removeClass('is-active');
          $('#js-menu').removeClass('is-no-active');
        });
    }else {
      //menuが閉じている場合
      $('#js-menu-btn').addClass('is-active');
      $('#js-menu').addClass('is-active');
    }
  });

  $('.l-nav__accordion').click(function(){
    $(this).next().slideToggle(300);
    $(this).toggleClass('is-open');
  });
}